export default __webpack_public_path__ + "static/media/mobile.65eb8571.jpg";